import React, { useEffect, useState } from "react";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import Axios from "../../../axios/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Supplier.css";

function CustomerReports() {
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [repeatedCustomers, setRepeatedCustomers] = useState([]);

  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);

      const config = {
        headers: {
          "x-supplier-id": supplierInfo.supplierId,
        },
      };

      Axios.get("/supplier/reports/customer-stats", config)
        .then((res) => {
          setTotalCustomers(res.data.totalCustomers || 0);
          setRepeatedCustomers(res.data.repeatedCustomers || []);
        })
        .catch((err) => {
          console.error("Error fetching customer data:", err);
        });
    }
  }, []);

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Customer Reports</h2>

              <div className="row g-4 mb-4">
                <div className="col-md-6 col-lg-4">
                  <div className="enhanced-card p-4 text-center">
                    <div className="card-icon-wrapper card-icon-info">
                      <i className="bi bi-people fs-2"></i>
                    </div>
                    <h6 className="text-muted">Total Customers</h6>
                    <div className="card-value">{totalCustomers}</div>
                  </div>
                </div>
              </div>

              <div className="table-responsive bg-white rounded shadow p-3">
                <h5 className="mb-3">Frequently Repeated Customers</h5>
                <table className="table table-hover">
                  <thead className="table-secondary">
                    <tr>
                      <th>Customer Name</th>
                      <th>Order Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {repeatedCustomers.length > 0 ? (
                      repeatedCustomers.map((customer, index) => (
                        <tr key={index}>
                          <td>{customer.name}</td>
                          <td>{customer.orderCount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center text-muted">
                          No repeated customers
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerReports;
